import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { tap, catchError, finalize } from 'rxjs/operators';
import { DataService } from './data.service';
import { LoggerManagerService } from './logger-manager.service';

@Injectable({
  providedIn: 'root',
})
export class ConsumeService {
  constructor(
    private readonly http: HttpClient,
    private readonly dataService: DataService,
    private readonly loggerService: LoggerManagerService
  ) { }

  httpGet<T>(url: string, params?: any, headers?: any, signal?: AbortSignal): Observable<T> {
    const httpHeaders = this.buildHeaders(headers);
    const httpParams = this.buildParams(params);

    this.dataService.setIsLoading(true);

    return this.http.get<T>(url, { headers: httpHeaders, params: httpParams, ...(signal && { signal }) }).pipe(
      tap(() => this.dataService.setIsLoading(false)),
      catchError((error) => {
        this.loggerService.exception(error, true);
        throw error;
      }),
      finalize(() => this.dataService.setIsLoading(false))
    );
  }

  httpDelete<T>(url: string, params?: any, headers?: any, signal?: AbortSignal): Observable<T> {
    const httpHeaders = this.buildHeaders(headers);
    const httpParams = this.buildParams(params);

    this.dataService.setIsLoading(true);

    return this.http.delete<T>(url, { headers: httpHeaders, params: httpParams, ...(signal && { signal }) }).pipe(
      tap(() => this.dataService.setIsLoading(false)),
      catchError((error) => {
        this.loggerService.exception(error, true);
        throw error;
      }),
      finalize(() => this.dataService.setIsLoading(false))
    );
  }

  httpPost<T>(url: string, body: any, headers?: any, signal?: AbortSignal): Observable<T> {
    const httpHeaders = this.buildHeaders(headers);

    this.dataService.setIsLoading(true);

    return this.http.post<T>(url, body, { headers: httpHeaders, ...(signal && { signal }) }).pipe(
      tap(() => this.dataService.setIsLoading(false)),
      catchError((error) => {
        this.loggerService.exception(error, true);
        throw error;
      }),
      finalize(() => this.dataService.setIsLoading(false))
    );
  }

  httpPut<T>(url: string, body: any, headers?: any, signal?: AbortSignal): Observable<T> {
    const httpHeaders = this.buildHeaders(headers);

    this.dataService.setIsLoading(true);

    return this.http.put<T>(url, body, { headers: httpHeaders, ...(signal && { signal }) }).pipe(
      tap(() => this.dataService.setIsLoading(false)),
      catchError((error) => {
        this.loggerService.exception(error, true);
        throw error;
      }),
      finalize(() => this.dataService.setIsLoading(false))
    );
  }

  httpPatch<T>(url: string, body?: any, headers?: any, signal?: AbortSignal): Observable<T> {
    const httpHeaders = this.buildHeaders(headers);

    this.dataService.setIsLoading(true);

    return this.http.patch<T>(url, body, { headers: httpHeaders, ...(signal && { signal }) }).pipe(
      tap(() => this.dataService.setIsLoading(false)),
      catchError((error) => {
        this.loggerService.exception(error, true);
        throw error;
      }),
      finalize(() => this.dataService.setIsLoading(false))
    );
  }

  private buildHeaders(headers?: any): HttpHeaders {
    let httpHeaders = new HttpHeaders();
    if (headers) {
      for (const [key, value] of Object.entries(headers)) {
        httpHeaders = httpHeaders.append(key, value as string);
      }
    }
    return httpHeaders;
  }

  private buildParams(params?: any): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        httpParams = httpParams.append(key, value as string);
      }
    }
    return httpParams;
  }
}
